module.exports = __webpack_public_path__ + "static/img/accompanying-run.0215b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/specialist/accompanying-run.png
// module id = ImVB
// module chunks = 1